'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sidebar = require('./sidebar');

var _sidebar2 = _interopRequireDefault(_sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _sidebar2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-sidebar/dist-modules/index.js
 ** module id = 804
 ** module chunks = 0
 **/